const STORAGE_KEY = 'box21_last_opened_projects';
const MAX_ITEMS = 20;

/**
 * @returns {Array<number|string>}
 */
export function getLastOpenedProjectIds() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return [];
    }
    return parsed.filter((id) => id != null && id !== false && id !== '');
  } catch (e) {
    return [];
  }
}

/**
 * Record that a project was opened (most recent first).
 * @param {number|string|boolean|null|undefined} projectId
 */
export function recordLastOpenedProject(projectId) {
  if (projectId == null || projectId === false || projectId === '' || projectId === 'false') {
    return;
  }
  const id = typeof projectId === 'number' ? projectId : String(projectId);
  if (id === 'NaN' || Number.isNaN(Number(id))) {
    return;
  }
  try {
    const normalized = String(id);
    let list = getLastOpenedProjectIds().map(String).filter((x) => x !== normalized);
    list.unshift(normalized);
    list = list.slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch (e) {
    /* quota or private mode */
  }
}

/**
 * Sort projects so last-opened ones appear first (most recent first).
 * Relative order of non-recent projects is preserved.
 * @template {{ id: * }} T
 * @param {T[]} projects
 * @returns {T[]}
 */
export function sortProjectsByLastOpened(projects) {
  const lastOpened = getLastOpenedProjectIds().map(String);
  if (!lastOpened.length || !projects || !projects.length) {
    return projects || [];
  }
  const rank = new Map(lastOpened.map((id, i) => [id, i]));
  return [...projects]
    .map((p, index) => ({ p, index }))
    .sort((a, b) => {
      const ra = rank.has(String(a.p.id)) ? rank.get(String(a.p.id)) : Infinity;
      const rb = rank.has(String(b.p.id)) ? rank.get(String(b.p.id)) : Infinity;
      if (ra !== rb) {
        return ra - rb;
      }
      return a.index - b.index;
    })
    .map(({ p }) => p);
}

export function isLastOpenedProject(projectId) {
  if (projectId == null || projectId === false || projectId === '') {
    return false;
  }
  return getLastOpenedProjectIds().map(String).includes(String(projectId));
}
